import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { TableSelectors } from '../../../redux/selectors';
import TableCaption from '../TableCaption';
import Table from '../Table';
import RatingFeedback from './FeedbackInfo';
import { PAGINATION } from '../../../../../shared/constants';

const FeedbacksTable = ({
  tableCaption,
  renderCell,
  columns,
  data,
  fetchData,
  isLoading,
  feedbackFilter,
  selectedFilters,
  colSpan,
  ratingIdFromParams,
  datePickers,
}) => {
  const pagination = useSelector(TableSelectors.selectPagination);

  const onRowClick = useCallback((event, row) => row.toggleRowExpanded(), []);

  const captionComponent = (
    <TableCaption
      title={tableCaption}
      filter={feedbackFilter}
      selectedCheckboxes={selectedFilters}
      datePickers={datePickers}
    />
  );

  return (
    <Table
      caption={captionComponent}
      renderCell={renderCell}
      columns={columns}
      data={data}
      manualPagination
      manualSortBy
      fetchData={fetchData}
      CustomExpandedRow={RatingFeedback}
      initialState={{ sortBy: [{ id: 'lastRated', desc: true }] }}
      isLoading={isLoading}
      isPaginationHidden={pagination.rowsTotalCount < PAGINATION.minDataCount}
      onRowClick={onRowClick}
      expandSubRows={false}
      colSpan={colSpan}
      activeElementKey={ratingIdFromParams}
    />
  );
};

FeedbacksTable.propTypes = {
  tableCaption: PropTypes.string.isRequired,
  renderCell: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  fetchData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  feedbackFilter: PropTypes.shape({
    getSelectedFilters: PropTypes.func,
  }).isRequired,
  selectedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  colSpan: PropTypes.string,
  ratingIdFromParams: PropTypes.string,
};

FeedbacksTable.defaultProps = {
  colSpan: '10',
  ratingIdFromParams: '',
};

export default FeedbacksTable;
